/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import axios from '@/plugins/axios'
import { downLoad } from '@/utils'
import {
  putsavePageItem,
  getgetTipsList,
  postsaveTips,
  putupdateTips,
  deletedeleteTips,
  postresetSystemSettings,
  putorder,
  postsaveText,
  putupdateText,
  deletedeleteText,
  getgetTextList,
  getgetSettingList,
  getgetSystemDefault,
  getexportSettings
} from './model'
import {ValidateType} from './model/utils'
const isPod = process.env.NODE_ENV === 'production'

let validatesavePageItem = new ValidateType(putsavePageItem.Req, '/page/savePageItem', 'PUT')
export function savePageItem (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesavePageItem.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/savePageItem',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    disabledData: true,
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetTipsList = new ValidateType(getgetTipsList.Req, '/page/getTipsList', 'GET')
export function getTipsList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetTipsList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/getTipsList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesaveTips = new ValidateType(postsaveTips.Req, '/page/saveTips', 'POST')
export function saveTips (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesaveTips.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/saveTips',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateupdateTips = new ValidateType(putupdateTips.Req, '/page/updateTips', 'PUT')
export function updateTips (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateupdateTips.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/updateTips',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatedeleteTips = new ValidateType(deletedeleteTips.Req, '/page/deleteTips', 'DELETE')
export function deleteTips (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatedeleteTips.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/deleteTips',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateresetSystemSettings = new ValidateType(postresetSystemSettings.Req, '/page/resetSystemSettings', 'POST')
export function resetSystemSettings (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateresetSystemSettings.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/resetSystemSettings',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateorder = new ValidateType(putorder.Req, '/page/order', 'PUT')
export function order (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateorder.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/order',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatesaveText = new ValidateType(postsaveText.Req, '/page/saveText', 'POST')
export function saveText (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatesaveText.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/saveText',
    method: 'POST',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateupdateText = new ValidateType(putupdateText.Req, '/page/updateText', 'PUT')
export function updateText (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validateupdateText.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/updateText',
    method: 'PUT',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validatedeleteText = new ValidateType(deletedeleteText.Req, '/page/deleteText', 'DELETE')
export function deleteText (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validatedeleteText.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/deleteText',
    method: 'DELETE',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetTextList = new ValidateType(getgetTextList.Req, '/page/getTextList', 'GET')
export function getTextList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetTextList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/getTextList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSettingList = new ValidateType(getgetSettingList.Req, '/page/getSettingList', 'GET')
export function getSettingList (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSettingList.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/getSettingList',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validategetSystemDefault = new ValidateType(getgetSystemDefault.Req, '/page/getSystemDefault', 'GET')
export function getSystemDefault (req, config = {}, filterKey = []) {
  // 生产环境去除校验，提升性能
  !isPod && validategetSystemDefault.setFilterKey(filterKey).validate(req)
  return axios({
    url: '/page/getSystemDefault',
    method: 'GET',
    data: req,
    ...config
  }).then(({ data }) => {
    return data
  })
}

let validateexportSettings = new ValidateType(getexportSettings.Req, '/page/exportSettings', 'GET')
export function exportSettings (req, config = {}, filterKey = []) {
  downLoad('/page/exportSettings', req)
}